import { TYPES } from './actions';
import { merge } from '../../../../utils/state';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  pagination: null,
  isLoadingMore: false,
  selectedCandidateDetails: {},
  isLoadingNotes: false,
  isLoadingMoreNotes: false,
  isCreatingOrUpdatingNote: false,
  isSelectedCandidateDetailsLoading: false,
  isHidingOrUnhidingCandidates: false,
  isRatingCandidates: false,
  isForwardCandidates: false,
  notes: {
    content: [],
    pagination: {},
    error: null,
    isLoading: false,
  },
  screenerAnswers: {
    isLoading: false,
    data: [],
    error: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SCREENER_ANSWERS_CANDIDATES_REQUEST:
      return merge(state, {
        screenerAnswers: {
          ...state.screenerAnswers,
          isLoading: true,
        },
      });
    case TYPES.SCREENER_ANSWERS_CANDIDATES_SUCCESS:
      return merge(state, {
        screenerAnswers: {
          ...state.screenerAnswers,
          isLoading: false,
          data: action.payload,
        },
      });
    case TYPES.SCREENER_ANSWERS_CANDIDATES_ERROR:
      return merge(state, {
        screenerAnswers: {
          ...state.screenerAnswers,
          isLoading: false,
          data: [],
          error: action.payload,
        },
      });
    case TYPES.GET_CANDIDATES_REQUEST:
      return merge(state, {
        isLoading: true,
      });
    case TYPES.FORWARD_CANDIDATES_REQUEST:
      return merge(state, {
        isForwardCandidates: true,
      });
    case TYPES.FORWARD_CANDIDATES_ERROR:
    case TYPES.FORWARD_CANDIDATES_SUCCESS:
      return merge(state, {
        isForwardCandidates: false,
      });
    case TYPES.GET_CANDIDATES_LOAD_MORE_REQUEST:
      return merge(state, {
        error: null,
        isLoadingMore: true,
      });
    case TYPES.HIDE_CANDIDATES_REQUEST:
    case TYPES.UNHIDE_CANDIDATES_REQUEST:
      return merge(state, {
        error: null,
        isHidingOrUnhidingCandidates: true,
      });
    case TYPES.GET_CANDIDATE_DETAILS_REQUEST:
      return merge(state, {
        error: null,
        isSelectedCandidateDetailsLoading: true,
      });
    case TYPES.GET_CANDIDATES_NOTES_LIST_REQUEST:
      return merge(state, {
        isLoadingNotes: true,
        notes: {
          ...state.notes,
          error: null,
        },
      });
    case TYPES.CREATE_CANDIDATES_NOTE_REQUEST:
      return merge(state, {
        isCreatingOrUpdatingNote: true,
        notes: {
          ...state.notes,
          error: null,
        },
      });
    case TYPES.UPDATE_CANDIDATES_NOTE_REQUEST:
      return merge(state, {
        isCreatingOrUpdatingNote: true,
        notes: {
          ...state.notes,
          error: null,
        },
      });
    case TYPES.GET_CANDIDATES_MORE_NOTES_LIST_REQUEST:
      return merge(state, {
        isLoadingMoreNotes: true,
        notes: {
          ...state.notes,
          error: null,
        },
      });
    case TYPES.RATE_CANDIDATE_REQUEST:
    case TYPES.BULK_RATE_CANDIDATES_REQUEST:
      return merge(state, {
        error: null,
        isRatingCandidates: true,
      });
    case TYPES.GET_CANDIDATES_SUCCESS:
      return merge(state, {
        isLoading: false,
        error: null,
        data: action.payload.content,
        pagination: action.payload.pagination,
      });
    case TYPES.GET_CANDIDATES_LOAD_MORE_SUCCESS:
      return merge(state, {
        data: [...state.data, ...action.payload.content],
        pagination: action.payload.pagination,
        error: null,
        isLoadingMore: false,
      });
    case TYPES.HIDE_CANDIDATES_SUCCESS: {
      let updatedData = [...state.data];
      updatedData = updatedData.map((item) => {
        const updatedItem = { ...item };
        if (action.payload.includes(updatedItem.id)) {
          updatedItem.is_visible = false;
        }
        return updatedItem;
      });
      return merge(state, {
        error: null,
        isHidingOrUnhidingCandidates: false,
        data: [...updatedData],
      });
    }
    case TYPES.UNHIDE_CANDIDATES_SUCCESS: {
      let updatedData = [...state.data];
      updatedData = updatedData.map((item) => {
        const updatedItem = { ...item };
        if (action.payload.includes(updatedItem.id)) {
          updatedItem.is_visible = true;
        }
        return updatedItem;
      });
      return merge(state, {
        error: null,
        isHidingOrUnhidingCandidates: false,
        data: [...updatedData],
      });
    }
    case TYPES.GET_CANDIDATE_DETAILS_SUCCESS:
      return merge(state, {
        selectedCandidateDetails: action.payload,
        error: null,
        isSelectedCandidateDetailsLoading: false,
      });
    case TYPES.GET_CANDIDATES_NOTES_LIST_SUCCESS:
      return merge(state, {
        isLoadingMoreNotes: false,
        notes: {
          ...state.notes,
          ...action.payload,
          error: null,
        },
      });
    case TYPES.CREATE_CANDIDATES_NOTE_SUCCESS:
      return merge(state, {
        isCreatingOrUpdatingNote: false,
        notes: {
          ...state.notes,
          content: [{ ...action.payload }, ...state.notes.content],
          pagination: {
            ...state.notes.pagination,
            element_total: state.notes.pagination.element_total + 1,
          },
          error: null,
        },
        selectedCandidateDetails: {
          ...state.selectedCandidateDetails,
          note_count: state.selectedCandidateDetails.note_count + 1,
        },
      });
    case TYPES.UPDATE_CANDIDATES_NOTE_SUCCESS:
      return merge(state, {
        isCreatingOrUpdatingNote: false,
        notes: {
          ...state.notes,
          content: [...state.notes.content.map((item) => {
            const updatedItem = { ...item };
            if (updatedItem.id === action.payload.noteId) {
              updatedItem.content = action.payload.content;
              updatedItem.updated_at = (new Date()).toISOString();
            }
            return updatedItem;
          })],
          error: null,
          isLoading: false,
        },
      });
    case TYPES.GET_CANDIDATES_MORE_NOTES_LIST_SUCCESS:
      return merge(state, {
        isLoadingMoreNotes: false,
        notes: {
          ...state.notes,
          content: [...state.notes.content, ...action.payload.content],
          pagination: action.payload.pagination,
          error: null,
        },
      });
    case TYPES.RATE_CANDIDATE_SUCCESS: {
      const currentNotesCount = state.selectedCandidateDetails.note_count;
      const updatedNotesCount = action.payload.incrementNotesCount ? currentNotesCount + 1 : currentNotesCount;
      return merge(state, {
        isRatingCandidates: false,
        selectedCandidateDetails: {
          ...state.selectedCandidateDetails,
          rating_current_profile: action.payload.currentProfileRating,
          rating_average: action.payload.averageRating,
          rating_count: action.payload.ratingCount,
          note_count: updatedNotesCount,
        },
        data: [...state.data.map((item) => {
          const updatedItem = { ...item };
          if (updatedItem.id === action.payload.candidateId) {
            updatedItem.rating_current_profile = action.payload.currentProfileRating;
            updatedItem.rating_average = action.payload.averageRating;
            updatedItem.rating_count = action.payload.ratingCount;
          }
          return updatedItem;
        })],
      });
    }
    case TYPES.BULK_RATE_CANDIDATES_SUCCESS: {
      const { rating, candidateIds } = action.payload;
      let updatedData = [...state.data];

      updatedData = updatedData.map((item) => {
        const updatedItem = { ...item };
        if (candidateIds.includes(updatedItem.id)) {
          if (updatedItem.rating_current_profile) {
            const sumOfRatings = updatedItem.rating_average * updatedItem.rating_count;
            const updatedSumOfRatings = sumOfRatings - updatedItem.rating_current_profile + rating;
            const updatedAverageRating = updatedSumOfRatings / updatedItem.rating_count;
            updatedItem.rating_average = updatedAverageRating;
          } else if (updatedItem.rating_count) {
            const sumOfRatings = updatedItem.rating_average * updatedItem.rating_count;
            const updatedSumOfRatings = sumOfRatings + rating;
            const updatedRatingCount = updatedItem.rating_count + 1;
            const updatedAverageRating = updatedSumOfRatings / updatedRatingCount;

            updatedItem.rating_count = updatedRatingCount;
            updatedItem.rating_average = updatedAverageRating;
          } else {
            updatedItem.rating_count += 1;
            updatedItem.rating_average = rating;
          }
          updatedItem.rating_current_profile = rating;
        }
        return updatedItem;
      });
      return merge(state, {
        error: null,
        isRatingCandidates: false,
        data: [...updatedData],
      });
    }
    case TYPES.GET_CANDIDATES_ERROR:
    case TYPES.GET_CANDIDATES_LOAD_MORE_ERROR:
    case TYPES.GET_CANDIDATE_DETAILS_ERROR:
    case TYPES.HIDE_CANDIDATES_ERROR:
    case TYPES.UNHIDE_CANDIDATES_ERROR:
    case TYPES.UPDATE_CANDIDATES_NOTE_ERROR:
    case TYPES.CREATE_CANDIDATES_NOTE_ERROR:
    case TYPES.GET_CANDIDATES_NOTES_LIST_ERROR:
    case TYPES.GET_CANDIDATES_MORE_NOTES_LIST_ERROR:
    case TYPES.RATE_CANDIDATE_ERROR:
    case TYPES.BULK_RATE_CANDIDATES_ERROR:
      return merge(state, {
        isLoading: false,
        isLoadingMore: false,
        isSelectedCandidateDetailsLoading: false,
        isLoadingNotes: false,
        isCreatingOrUpdatingNote: false,
        isLoadingMoreNotes: false,
        isHidingOrUnhidingCandidates: false,
        isRatingCandidates: false,
        error: action.payload,
      });
    case TYPES.RESET_NOTES_STATE:
      return merge(state, {
        notes: {
          ...state.notes,
          content: [],
          pagination: {},
        },
      });
    default:
      return state;
  }
};

export default reducer;
